import { useEffect, useState, useRef, useMemo } from "react";
import RootRef from "@material-ui/core/RootRef";
import {
	FormControl,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Select,
	Tab,
	Tabs,
	Typography,
	Badge,
	Box,
	Alert,
	InputLabel,
	ListItemSecondaryAction,
	Grid,
	TextField,
	InputAdornment,
	CircularProgress,
	Tooltip,
	Fade,
	LinearProgress,
} from "@mui/material";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import SearchIcon from "@mui/icons-material/Search";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import FavoriteIcon from "@mui/icons-material/FavoriteRounded";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { ReactComponent as AllPartnerIcon } from "../../assets/icons/all-biller.svg";
import { ReactComponent as AllPartnerIconActive } from "../../assets/icons/all-biller-active.svg";
import { ReactComponent as ClearIcon } from "../../assets/icons/clear-search.svg";
import { ReactComponent as SortUpIcon } from "../../assets/icons/sort-up.svg";
import { ReactComponent as SortDownIcon } from "../../assets/icons/sort-down.svg";
import { ReactComponent as AddPartnerIcon } from "../../assets/icons/add-biller.svg";
import { ReactComponent as AddPartnerActiveIcon } from "../../assets/icons/add-biller-active.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import debounce from "lodash/debounce";
import { getCookie } from "../../utils/cookies";
import "./BillerListPanel.css";
import HTTP from "../../helpers/ApiClient";
import _ from "lodash";
import {
	partnerActionCreator,
	listPartners,
	setProductStatus,
	toggleServiceFeeRetryDialog,
	resetCustomPartnerServiceFee,
} from "../../redux/modules/partnerList";
import { useSelector, useDispatch } from "react-redux";
import BFAStatus, { PRODUCT_CODE } from "../BillerList/BFAStatus";
import { resetValidated } from "../../redux/modules/validationBuyLoad";
import { getSessionStorage, setSessionStorage } from "../../utils/storage";
import CustomSnackbar from "../common/Snackbar/Snackbar";
import { showAlert } from "../../redux/modules/alert";
const notificationMessage = {
	add: " has been successfully added to favorites.",
	remove: " has been successfully removed from favorites.",
	move: " has been successfully moved.",
	failed: "Sorry, we encountered a problem upon doing this request. ",
	max: "Only a max of 20 partners can be added to favorites.",
};

import { getBuyLoadPartnerList } from "../../utils/buyLoadApi3";

// SX
const styles = {
	tab: {
		textTransform: "None",
		"&.Mui-selected": { color: "#FB7823" },
		minHeight: "50px",
		height: "50px",
		alignItems: "start",
		font: "normal normal normal 14px/16px Poppins-Medium !important",
	},
	categoryWrapper: {
		marginBlock: "5px",
		display: "grid",
		gridTemplateColumns: "40%  min-content",
		gap: "5px",
	},
	categoryLabel: {
		color: "black",
		margin: "auto",
	},
	alertSucess: {
		background: "green",
		color: "white",
		borderRadius: "10px",
		paddingTop: "7px",
		paddingBottom: "7px",
		paddingRight: "7px",
		width: "calc(100% - 30px)",
	},
	alertError: {
		background: "#D32F2F",
		color: "white",
		borderRadius: "10px",
		paddingTop: "7px",
		paddingBottom: "7px",
		paddingRight: "7px",
		width: "calc(100% - 30px)",
	},
	searchField: {
		padding: "10px",
		height: "40px",
		backgroundColor: "#F5F5F5",
		borderRadius: "5px",
		font: "normal normal normal 14px/16px Poppins-Regular",
		"& .MuiInput-underline:after": {
			borderBottomColor: "orange",
		},
		underlineColor: {
			"& .MuiInput-underline:after": {
				borderBottomColor: "#fb7823",
			},
		},
	},
	partnerLoading: {
		height: "2px",
		width: "100%",
		overflow: "hidden",
		backgroundColor: "#FB7823",
		"& .MuiLinearProgress-bar": {
			backgroundColor: `#FAA268`,
		},
	},
	itemDestination: {
		borderStyle: "dashed",
		borderWidth: "2px",
		borderColor: "#FFBE38",
	},
};
function PartnerListPanel(props) {
	const [isLoading, setLoading] = useState(true); // Get partner list loading
	const [dragDestination, setDragDestination] = useState();
	const [partnerSelected, setPartnerSelected] = useState("");
	const [requestedPartner, setRequestedPartner] = useState("");
	const [searchValue, setSearchValue] = useState("");
	const [partnerList, setPartnerList] = useState([]);
	const [payBillStatus, setPayBillStatus] = useState();
	const [partnerStatus, setPartnerStatus] = useState();
	const [showBFA, setShowBFA] = useState(false);
	const [categoryList, setCategoryList] = useState([]);
	const [favoritesCount, setFavoritesCount] = useState(0);
	const [loadingIndicator, setLoadingIndicator] = useState(false);

	const searchRef = useRef();
	const [filterState, setFilterState] = useState({
		favorites: [],
		isSortAsc: true,
		search: "",
		filterFavorite: false,
		selectedCategory: "All",
	});
	const [alertOpen, setAlertOpen] = useState(false);
	const { filterFavorite, isSortAsc, selectedCategory } = filterState;
	const dispatch = useDispatch();
	const { partners, isLoadingSelectedPartner, isPartnerSuccess } =
		useSelector((store) => store.partnerList);
	const requiredKeys = [
		"name",
		"code",
		"category",
		"logo",
		"isFavorite",
		"orderFavorite",
	];
	const filterFavoritePartners = (partners) => {
		partners = _.filter(partners, ["isFavorite", 1]);
		return partners;
	};
	const handleCloseAlert = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setAlertOpen(false);
	};
	const handleAlert = () => {};
	const filterChange = () => {
		var filteredList = [...partners];
		setFavoritesCount(filterFavoritePartners(filteredList).length);
		// category
		if (selectedCategory !== "All" && !filterFavorite) {
			filteredList = filteredList.filter((partner) => {
				return (
					partner.category
						.toLowerCase()
						.indexOf(selectedCategory.toLowerCase()) !== -1
				);
			});
		}
		if (filterFavorite) {
			let favoritePartners = filterFavoritePartners(filteredList);
			favoritePartners = _.sortBy(
				favoritePartners,
				["orderFavorite"],
				["asc"]
			);
			filteredList = favoritePartners;
		}
		// Sort
		if (!filterFavorite) {
			if (isSortAsc == false) {
				filteredList = filteredList.sort(function (a, b) {
					return b.name.localeCompare(a.name);
				});
			}
			// search
			filteredList = filteredList.filter((partner) => {
				return (
					partner.name
						.toLowerCase()
						.indexOf(searchRef.current.value.toLowerCase()) !== -1
				);
			});
		}
		setPartnerList(filteredList);
		getCategoryList(filteredList);
	};
	function updateFavorites(tempPartners, partnerName, action = "") {
		setPartnerSelected(partnerName);
		setLoadingIndicator(true);
		const payload = favoriteListRequest(tempPartners);
		HTTP.put("v2/buyload/favorites", {
			data: payload,
		})
			.then((response) => {
				dispatch(
					showAlert({
						message: `${partnerName.replace(
							/\w+/g,
							_.capitalize
						)} ${notificationMessage[action]}`,
						severity: "success",
						duration: 5000,
					})
				);
				setDragDestination("");
				setLoadingIndicator(false);
				dispatch(
					listPartners({
						partners: tempPartners,
					})
				);
				setSessionStorage("partners", tempPartners);
				setPartnerList(tempPartners);
				getCategoryList(tempPartners);
			})
			.catch((error) => {
				setDragDestination("");
				setLoadingIndicator(false);
				dispatch(
					showAlert({
						message: notificationMessage.error,
						severity: "error",
						duration: 5000,
					})
				);
			});
	}
	// check if a value can be parsed as JSON and valid array of object
	function isValidArrayOfObjects(value) {
		try {
			const parsedValue = JSON.parse(value);
			return (
				Array.isArray(parsedValue) &&
				parsedValue.length > 0 &&
				parsedValue.every(
					(item) => typeof item === "object" && item !== null
				)
			);
		} catch (error) {
			return false; // If parsing as JSON fails, return false
		}
	}
	function hasRequiredKeys(arrayOfObjects) {
		// Check each object in the array
		return arrayOfObjects.every((obj) => {
			// Check if all required keys are present in the object
			return requiredKeys.every((key) => key in obj);
		});
	}
	function hasValue(value) {
		if (value.length !== 0) {
			return true;
		}
		return false;
	}
	function setCachedExpiration() {
		const date = new Date();
		const minute = 5;
		const expiration = date.setTime(date.getTime() + minute * 60_000);
		setSessionStorage("cachedExpiration", expiration);
	}
	function isCachedExpired() {
		let result = true;
		const expiration = getSessionStorage("cachedExpiration");
		if (expiration) {
			const time_now = new Date();
			if (time_now <= expiration) {
				result = false;
			}
		}
		return result;
	}
	async function getPartnerList() {
		let cachedPartners = [];
		setLoading(true);
		// checking valid cached partner list from session storage
		if (isValidArrayOfObjects(sessionStorage.getItem("partners"))) {
			const parsedValue = JSON.parse(sessionStorage.getItem("partners"));
			if (hasRequiredKeys(parsedValue)) {
				cachedPartners = parsedValue;
			}
		}

		if (hasValue(cachedPartners) && isCachedExpired() == false) {
			const cPartnerList = cachedPartners.map((x) => ({
				...x,
				isSelected: false,
			}));

			cachedPartners = cPartnerList;
			dispatch(
				listPartners({
					partners: cachedPartners,
				})
			);
			setSessionStorage("partners", cachedPartners);
			setPartnerList(cachedPartners);
			getCategoryList(cachedPartners);
		} else {
			const partnerListData = await getBuyLoadPartnerList();
			const aPartnerList = partnerListData.data.map((x) => ({
				...x,
				isSelected: false,
			}));

			cachedPartners = aPartnerList;
			setSessionStorage("partners", cachedPartners);
			setCachedExpiration();
			dispatch(
				listPartners({
					partners: cachedPartners,
				})
			);
			setPartnerList(cachedPartners);
			getCategoryList(cachedPartners);
		}
		setLoading(false);
	}
	function getProductStatus() {
		HTTP.get(`/v3/product/status/${PRODUCT_CODE.BillsPayment}`)
			.then((response) => {
				dispatch(setProductStatus(response.data));
				setPayBillStatus({ ...response.data, initial: true });
			})
			.catch((error) => {
				console.error("Error on Bills Payment Status:", error);
			})
			.finally(() => {
				getPartnerList();
			});
	}
	const getCategoryList = (partnerList) => {
		if (partnerList && partnerList.length > 0) {
			let categoryList = _.uniqBy(partnerList, "category").map(
				(data) => data.category
			);
			setSessionStorage("partnerCategories", categoryList);
			setCategoryList(categoryList);
		}
	};
	const mutateFilterState = (object) => {
		setFilterState({ ...filterState, ...object });
	};

	const handleTabChange = () => {
		mutateFilterState({ filterFavorite: !filterFavorite });
	};
	const handleSortChange = () => {
		mutateFilterState({ isSortAsc: !isSortAsc });
	};
	const handleSelectedCategoryChange = (event) => {
		mutateFilterState({ selectedCategory: event.target.value });
	};
	const handleSearchChange = () => {
		setSearchValue(searchRef.current.value);
		filterChange();
	};
	const debounceOnChange = useMemo(
		() => debounce(handleSearchChange, 350),
		[searchValue, partners]
	);

	const checkPartnerServiceFeeStatus = (partnerCode) => {
		const list = getCookie("service_fee");
		const foundItem = list.find((item) => item.code === partnerCode);

		let showServiceFeeRetryDialog = getCookie("showServiceFeeRetryDialog");

		if (showServiceFeeRetryDialog == undefined) {
			showServiceFeeRetryDialog = true;
		}

		if (
			showServiceFeeRetryDialog == true &&
			foundItem.isRequestSuccessful == false
		) {
			dispatch(toggleServiceFeeRetryDialog());
		}
	};

	function favoriteListRequest(list) {
		// filter favorites from partner list
		let favorites = filterFavoritePartners(list);
		// sort by correct order
		favorites = _.sortBy(favorites, ["orderFavorite"], ["asc"]);
		// get partner codes only
		favorites = favorites.map((item) => {
			return item.code;
		});
		// format list of partner
		favorites = `['${favorites.join(`','`)}']`;
		return favorites;
	}
	const handleDragFavorite = (source, destination) => {
		// swap position
		let tempPartners = partners;
		tempPartners = tempPartners.map((a) => {
			var returnValue = { ...a };
			if (a.orderFavorite == source[0].orderFavorite) {
				returnValue.orderFavorite = destination[0].orderFavorite;
			}
			if (a.orderFavorite == destination[0].orderFavorite) {
				returnValue.orderFavorite = source[0].orderFavorite;
			}
			return returnValue;
		});
		setDragDestination(destination[0].code);
		updateFavorites(tempPartners, source[0].name, "move");
	};
	const handleAddToFavorites = (partner) => {
		if (favoritesCount >= 20) {
			dispatch(
				showAlert({
					message: `${notificationMessage.max}`,
					severity: "error",
					duration: 5000,
				})
			);
			return;
		}
		const { code, name } = partner;
		// Adding the favorite tag of the partner requested
		let tempPartners = partners;
		tempPartners = tempPartners.map((item) => {
			var returnValue = { ...item };
			if (item.code == code) {
				returnValue.orderFavorite = favoritesCount + 1;
				returnValue.isFavorite = 1;
			}
			return returnValue;
		});
		updateFavorites(tempPartners, name, "add");
	};
	const handleUnFavorite = (partner) => {
		const { code, name } = partner;
		let newPartners = partners;
		// Removing the favorite tag of the partner requested
		newPartners = newPartners.map((item) => {
			var returnValue = { ...item };
			if (item.code == code) {
				returnValue.orderFavorite = 0;
				returnValue.isFavorite = 0;
			}
			return returnValue;
		});
		// Correcting orderFavorite value
		let tempPartners = filterFavoritePartners(newPartners);
		tempPartners = _.sortBy(tempPartners, ["orderFavorite"], ["asc"]);
		tempPartners.forEach((item, index) => {
			item.orderFavorite = index + 1;
		});
		newPartners = newPartners.map((item) => {
			var returnValue = { ...item };
			tempPartners.forEach((favItem) => {
				if (item.code == favItem.code) {
					return { ...favItem };
				}
			});
			return returnValue;
		});
		updateFavorites(newPartners, name, "remove");
	};

	async function handleSelectedPartner(partner) {

		if (!payBillStatus?.api3_status || !payBillStatus?.bfaap_status) {
			setPayBillStatus({ ...payBillStatus, initial: false });
			setShowBFA(true);
		} else {
			setLoadingIndicator(true);
			const { code, name, is_enabled, is_api3_enabled } = partner;
			const isActive = is_api3_enabled && is_enabled;
			setPartnerStatus({
				api3: is_api3_enabled,
				bfaap: is_enabled,
				isActive,
			});
			if (!isActive) {
				setLoadingIndicator(false);
				setShowBFA(true);
			} else {
				setRequestedPartner(code);
				setPartnerSelected(name);
				try {
					dispatch(
						partnerActionCreator({
							code: partner.code,
						})
					);
					dispatch(resetCustomPartnerServiceFee());
					dispatch(resetValidated());
				} catch (error) {
					console.log(error);
				} finally {
					setLoading(false);
					setLoadingIndicator(false);
				}
				// checkPartnerServiceFeeStatus(partner.code);
			}
		}
	}
	const tagSelectedPartner = () => {
		var selectedPartners = partners.map((partner) => {
			if (partner.code === requestedPartner) {
				return { ...partner, isSelected: !partner.isSelected };
			}
			return { ...partner };
		});
		dispatch(
			listPartners({
				partners: selectedPartners.map((x) => ({
					...x,
				})),
			})
		);
	};
	const beforeRefresh = () => {
		if (hasValue(partners)) {
			setSessionStorage("partners", partners);
			getCategoryList(partners);
		}
	};
	// making sure user is in the favorite partners
	const checkPartnerPaneStatus = () => {
		// check if the user is in the
		if (filterFavorite == true) {
			if (loadingIndicator == true) {
				return true;
			} else {
				return false;
			}
		} else {
			return true;
		}
	};
	useEffect(() => {
		const handleUnload = (e) => {
			// Perform actions before the component unloads
			beforeRefresh();
		};
		window.addEventListener("unload", handleUnload);
		return () => {
			window.removeEventListener("unload", handleUnload);
		};
	}, [partners]);
	useEffect(() => {
		getProductStatus();
	}, []);
	useEffect(() => {
		filterChange();
	}, [filterState, partners]);
	useEffect(() => {
		if (isPartnerSuccess) {
			tagSelectedPartner();
		}
	}, [isPartnerSuccess]);
	const onClear = () => {
		searchRef.current.value = "";
		setSearchValue("");
		filterChange();
	};
	const replaceImage = (error) => {
		error.target.src =
			"https://cbci-mecom-dev-api-images.s3-ap-southeast-1.amazonaws.com/biller-logos/drafts/DEFAULT.png";
	};
	const onDragEnd = (event) => {
		if (!event.destination) {
			return;
		}
		if (event.source.index == event.destination.index) {
			return;
		}
		const favoriteList = filterFavoritePartners(partners);
		const source = _.filter(favoriteList, [
			"orderFavorite",
			event.source.index + 1,
		]);
		const destination = _.filter(favoriteList, [
			"orderFavorite",
			event.destination.index + 1,
		]);
		// For drag and drop CSS Identifier
		setDragDestination(destination[0].code);
		setPartnerSelected(source[0].name);
		handleDragFavorite(source, destination);
	};
	const getItemStyle = (isDragging, draggableStyle) => ({
		// styles we need to apply on draggables
		...draggableStyle,
		...(isDragging && {
			background: "#CACACA",
			height: "50px",
		}),
		height: "50px",
		background: "#F7FBFF",
		marginBottom: "4px",
		padding: "3px",
		borderRadius: "10px",
	});
	const getListStyle = (isDraggingOver) => ({
		background: isDraggingOver ? "white" : "white",
	});

	return (
		<>
			<BFAStatus
				show={showBFA}
				productStatus={payBillStatus}
				partnerStatus={partnerStatus}
				callback={() => setShowBFA(false)}
			/>
			<Box display={"grid"} gridAutoFlow={"row"} gap="5px">
				<Box
					gridRow={1 / -1}
					gridColumn={1 / -1}
					style={{ minWidth: "220px" }}
				>
					<Box style={{ marginBottom: "4px" }}>
						<Tabs
							value={filterFavorite}
							disableRipple
							onChange={() => {
								handleTabChange();
							}}
							TabIndicatorProps={{
								style: {
									transition: "none",
									display: "none",
								},
							}}
							sx={{ maxHeight: "0px" }}
							style={{
								...(filterFavorite && {
									minHeight: "37px",
									height: "37px",
								}),
							}}
						>
							<Tab
								disableRipple
								label="Partners"
								value={false}
								icon={
									!filterFavorite ? (
										<AllPartnerIconActive
											style={{
												height: "20px",
												width: "20px",
											}}
										/>
									) : (
										<AllPartnerIcon
											style={{
												height: "20px",
												width: "20px",
											}}
										/>
									)
								}
								iconPosition="start"
								sx={styles.tab}
								style={{
									marginRight: "25px",
									marginLeft: "10px",
								}}
							/>
							<Tab
								disableRipple
								label="Favorite Partners"
								value={true}
								sx={styles.tab}
								icon={
									<Badge
										color="secondary"
										sx={{
											"& .MuiBadge-badge": {
												color: `${
													filterFavorite
														? "#FB7823"
														: "#8B9095"
												}`,
												backgroundColor: "#FBFBFB",
												borderColor: `${
													filterFavorite
														? "#FB7823"
														: "#8B9095"
												}`,
												borderStyle: "solid",
												borderWidth: "1px",
												height: "17px",
												maxWidth: "3px",
												fontSize: "9px",
											},
										}}
										badgeContent={favoritesCount}
									>
										<FavoriteIcon
											sx={{
												color: `${
													!filterFavorite
														? "#8B9095"
														: "#FB7823"
												}`,
											}}
										/>
									</Badge>
								}
								iconPosition="start"
							/>
						</Tabs>
						{!filterFavorite && (
							<>
								<Box display={"flex"} alignItems={"center"}>
									<FormControl
										variant="outlined"
										style={{
											minWidth: "calc(100% - 20%)",
										}}
									>
										<InputLabel
											className="category_label"
											htmlFor="outlined-age-native-simple"
										>
											Select Partner Categories
										</InputLabel>
										<Select
											fullWidth
											className="category_items"
											native
											value={selectedCategory}
											style={{ height: "42px" }}
											onChange={(e) => {
												handleSelectedCategoryChange(e);
											}}
											label={"Select Partner Categories "}
											inputProps={{
												name: "Select Partner Categories ",
												id: "outlined-age-native-simple",
											}}
										>
											<option value={"All"} key={"All"}>
												{"All"}
											</option>
											{categoryList.length > 0 &&
												categoryList.map((item) => (
													<option
														value={item}
														key={item}
													>
														{item}
													</option>
												))}
										</Select>
									</FormControl>
									<Box padding={"12px"}>
										<IconButton
											disableRipple
											style={{
												borderRadius: "8px",
												padding: "5px",
											}}
											onClick={() => {
												handleSortChange();
											}}
										>
											{isSortAsc ? (
												<SortDownIcon
													style={{
														height: "15px",
														width: "15px",
													}}
												/>
											) : (
												<SortUpIcon
													style={{
														height: "15px",
														width: "15px",
													}}
												/>
											)}
										</IconButton>
									</Box>
								</Box>
							</>
						)}
					</Box>
					{!filterFavorite && (
						<TextField
							fullWidth
							size="small"
							className="search"
							placeholder="Search partner here.."
							variant="standard"
							inputRef={searchRef}
							onChange={debounceOnChange}
							sx={{
								...styles.searchField.underlineColor,
							}}
							InputProps={{
								style: {
									...styles.searchField,
								},
								startAdornment: (
									<InputAdornment
										style={{ paddingRight: "4px" }}
									>
										<SearchIcon />
									</InputAdornment>
								),
								endAdornment: (
									<InputAdornment
										position="end"
										onClick={() => {
											onClear();
										}}
									>
										<ClearIcon
											style={{
												display: `${
													searchValue
														? "flex"
														: "none"
												}`,
												cursor: "pointer",
												height: "20px",
												width: "20px",
											}}
										/>
									</InputAdornment>
								),
							}}
						/>
					)}
					<Box
						style={{
							...(!filterFavorite
								? { height: "865px" }
								: { height: "965px" }),
							maxHeight: "100vh",
							overflow: "auto",
						}}
					>
						{isLoading && (
							<Box
								style={{
									height: "700px",
									maxHeight: "100vh",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item>
									<CircularProgress />
								</Grid>
							</Box>
						)}
						{!partners.length && !isLoading && (
							<Box
								style={{
									height: "700px",
									maxHeight: "100vh",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<Grid item>
									<Box
										display={"flex"}
										flexDirection={"column"}
										alignItems={"center"}
									>
										<ErrorOutlineRoundedIcon className="svg_icons" />
										<h5>There's no partner to show.</h5>
									</Box>
								</Grid>
							</Box>
						)}
						{favoritesCount == 0 &&
							filterFavorite == true &&
							isLoading !== true && (
								<Box
									style={{
										height: "700px",
										maxHeight: "100vh",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<Grid item>
										<Box
											sx={{
												display: "flex",
												justifyContent: "center",
												marginBottom: "15px",
											}}
										>
											<LightbulbIcon
												className="svg_icons"
												sx={{ color: "#FB9451" }}
											/>
										</Box>
										<Typography
											sx={{
												textAlign: "center",
												width: "200px",
											}}
											variant="body1"
											className="favorite-note"
										>
											Favorite some partners so you can
											quickly find it here.
										</Typography>
									</Grid>
								</Box>
							)}
						<List>
							{isLoading == false && (
								<>
									<DragDropContext
										onDragEnd={(e) => {
											onDragEnd(e);
										}}
									>
										<Droppable droppableId="droppable">
											{(provided, snapshot) => (
												<RootRef
													rootRef={provided.innerRef}
													key={provided.draggableId}
												>
													<List
														style={getListStyle(
															snapshot.isDraggingOver
														)}
														key={
															provided.draggableId
														}
														disablePadding
													>
														{partnerList.map(
															(
																partner,
																index
															) => (
																<>
																	<Draggable
																		isDragDisabled={checkPartnerPaneStatus()}
																		key={
																			partner.code
																		}
																		draggableId={
																			partner.code
																		}
																		index={
																			index
																		}
																	>
																		{(
																			provided,
																			snapshot
																		) => (
																			<Box
																				display={
																					"grid"
																				}
																			>
																				{(loadingIndicator ||
																					isLoadingSelectedPartner) &&
																					partner.name ==
																						partnerSelected && (
																						<Box
																							gridRow={
																								1 /
																								-1
																							}
																							gridColumn={
																								1 /
																								-1
																							}
																							zIndex={
																								1600
																							}
																							xs={{
																								overflow:
																									"hidden",
																							}}
																							style={{
																								borderRadius:
																									"8px",
																								overflow:
																									"hidden",
																							}}
																						>
																							<LinearProgress
																								sx={{
																									...styles.partnerLoading,
																								}}
																							/>
																						</Box>
																					)}
																				<Box
																					gridRow={
																						1 /
																						-1
																					}
																					gridColumn={
																						1 /
																						-1
																					}
																				>
																					<ListItem
																						ref={
																							provided.innerRef
																						}
																						{...provided.draggableProps}
																						{...provided.dragHandleProps}
																						sx={{
																							...(partner.isFavorite ===
																								0 && {
																								"&:hover > button:nth-child(3) > svg":
																									{
																										color: "#8B9095",
																									},
																							}),
																							...(dragDestination ==
																								partner.code && {
																								...styles.itemDestination,
																							}),
																						}}
																						style={getItemStyle(
																							snapshot.isDragging,
																							provided
																								.draggableProps
																								.style
																						)}
																						disablePadding
																					>
																						<ListItemIcon>
																							<div className="logo-wrapper">
																								<img
																									className={
																										"logo"
																									}
																									src={
																										partner.logo
																									}
																									onError={
																										replaceImage
																									}
																								/>
																							</div>
																						</ListItemIcon>
																						<ListItemText
																							primary={
																								<Typography
																									variant="body2"
																									className="label"
																								>
																									{
																										partner.name
																									}
																								</Typography>
																							}
																							disableTypography
																						></ListItemText>
																						{partner.isFavorite !==
																							1 &&
																							loadingIndicator !==
																								true &&
																							isLoading !==
																								true && (
																								<IconButton
																									onClick={() => {
																										handleAddToFavorites(
																											partner
																										);
																									}}
																									sx={{
																										"&:hover > svg":
																											{
																												color: "red",
																											},
																									}}
																								>
																									<Tooltip title="Add to favorites">
																										<FavoriteBorderRoundedIcon
																											fontSize={
																												"small"
																											}
																											className="heart"
																											sx={{
																												"&:hover":
																													{
																														color: "red",
																													},
																												transition:
																													"color",
																												color: "#F7FBFF",
																											}}
																										/>
																									</Tooltip>
																								</IconButton>
																							)}
																						{partner.isFavorite ==
																							1 &&
																							isLoadingSelectedPartner &&
																							partner.name !==
																								partnerSelected &&
																							!loadingIndicator && (
																								<IconButton
																									disabled={
																										loadingIndicator
																									}
																									onClick={() => {
																										handleUnFavorite(
																											partner
																										);
																									}}
																								>
																									<Tooltip title="Remove to Favorites">
																										<FavoriteIcon
																											fontSize={
																												"small"
																											}
																											className="heart"
																											sx={{
																												"&:hover":
																													{},
																												transition:
																													"color",
																												color: "#FB7823",
																											}}
																										/>
																									</Tooltip>
																								</IconButton>
																							)}
																						{partner.isFavorite ==
																							1 &&
																							!isLoadingSelectedPartner && (
																								<IconButton
																									disabled={
																										loadingIndicator
																									}
																									onClick={() => {
																										handleUnFavorite(
																											partner
																										);
																									}}
																								>
																									<Tooltip title="Remove to Favorites">
																										<FavoriteIcon
																											fontSize={
																												"small"
																											}
																											className="heart"
																											sx={{
																												"&:hover":
																													{},
																												transition:
																													"color",
																												color: "#FB7823",
																											}}
																										/>
																									</Tooltip>
																								</IconButton>
																							)}
																						<ListItemIcon>
																							<ListItemSecondaryAction>
																								<IconButton
																									onClick={() => {
																										handleSelectedPartner(
																											partner
																										);
																									}}
																									disabled={
																										partner.isSelected ||
																										isLoadingSelectedPartner ||
																										loadingIndicator
																									}
																									sx={{
																										"&:hover":
																											{
																												color: "green",
																											},
																										transition:
																											"color",
																									}}
																								>
																									{partner.isSelected ==
																										false && (
																										<Tooltip title="Add to transaction">
																											<AddPartnerIcon className="svg_small" />
																										</Tooltip>
																									)}
																									{partner.isSelected &&
																										!isLoadingSelectedPartner && (
																											<AddPartnerActiveIcon className="svg_small" />
																										)}
																									{partner.isSelected &&
																										isLoadingSelectedPartner &&
																										partner.name !==
																											partnerSelected && (
																											<AddPartnerActiveIcon className="svg_small" />
																										)}
																								</IconButton>
																							</ListItemSecondaryAction>
																						</ListItemIcon>
																					</ListItem>
																				</Box>
																			</Box>
																		)}
																	</Draggable>
																</>
															)
														)}
														{provided.placeholder}
													</List>
												</RootRef>
											)}
										</Droppable>
									</DragDropContext>
								</>
							)}
						</List>
					</Box>
				</Box>
			</Box>
		</>
	);
}
export default PartnerListPanel;
